import React from 'react';
import { BotIcon, LayoutTemplateIcon, MailIcon, MapPinIcon, MessagesSquareIcon, MonitorIcon, PenLineIcon, PhoneIcon, Share2Icon, StarIcon, TargetIcon, ZapIcon } from 'lucide-react';
import type { NavIcon } from '../../data/navigation';
const icons = {
  mapPin: MapPinIcon,
  target: TargetIcon,
  penLine: PenLineIcon,
  share: Share2Icon,
  mail: MailIcon,
  phone: PhoneIcon,
  bot: BotIcon,
  messages: MessagesSquareIcon,
  star: StarIcon,
  monitor: MonitorIcon,
  zap: ZapIcon,
  layout: LayoutTemplateIcon
};
type NavIconGlyphProps = {
  icon: NavIcon;
  className?: string;
};
export function NavIconGlyph({
  icon,
  className
}: NavIconGlyphProps) {
  const Icon = icons[icon];
  return <Icon className={className} aria-hidden="true" data-id="element-682" data-mp="fwvztnizkuv" />;
}